import CareerBody from "../CareersBody"
import Header from "../Home/Screens/Header"
import ContentFooter from "../Services/Screens/ContentFooter"


const Careers = () => {

    return (
        <>

            <Header />
            <CareerBody />
            <ContentFooter />

        </>

    )
}


export default Careers